import { AlertTriangle } from 'lucide-react';
import { useSimilarTasks } from '../../hooks/useSimilarTasks';

export default function QuickAddBar({
  quickAdd, setQuickAdd, quickAddSchedule, setQuickAddSchedule, onQuickAdd,
}) {
  const similar = useSimilarTasks(quickAdd, null, quickAddSchedule !== 'inbox');
  return (
    <div className="px-4 py-3" style={{ background: 'var(--pd-panel)', borderTop: '1px solid var(--pd-border)' }}>
      <div className="flex gap-1.5 mb-2">
        {[['today', 'Today'], ['tomorrow', 'Tomorrow'], ['inbox', 'Inbox']].map(([key, label]) => (
          <button key={key} data-testid={`quick-add-schedule-${key}`}
            onClick={() => setQuickAddSchedule?.(key)}
            className="px-2 py-1 rounded-lg text-[9px] font-semibold"
            style={{
              background: quickAddSchedule === key ? 'var(--pd-focus)' : 'var(--pd-panel-2)',
              color: quickAddSchedule === key ? 'white' : 'var(--pd-muted)'
            }}>{label}</button>
        ))}
      </div>
      <input data-testid="quick-add-task-input" value={quickAdd || ''}
        onChange={(e) => setQuickAdd?.(e.target.value)} onKeyDown={onQuickAdd}
        placeholder={quickAddSchedule === 'inbox' ? '+ Capture to Inbox... (Enter)' : '+ Quick decision... (Enter)'}
        className="w-full px-3 py-2.5 rounded-xl text-[12px] outline-none"
        style={{ border: '1px dashed var(--pd-border)', color: 'var(--pd-text)', background: 'transparent' }}
        onFocus={(e) => { e.target.style.borderColor = 'var(--pd-focus)'; e.target.style.borderStyle = 'solid'; }}
        onBlur={(e) => { e.target.style.borderColor = 'var(--pd-border)'; e.target.style.borderStyle = 'dashed'; }}
      />
    </div>
  );
}
